import { useState, useEffect} from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import {Routes, Route, useNavigate } from 'react-router-dom';
import AppBar from './components/AppBar';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Home from './routes/Home';
import WorkingOnSite from './routes/WorkingOnSite';
import MemberOfThePublic from './routes/MemberOfThePublic';
import ImageUpload from './routes/ImageUpload';
import Contact from './routes/Contact';
import Success from './routes/Success';
import Error from './routes/ErrorPage';
import PageTracker from './PageTracker';
import { ErrorPopupProvider } from "./components/ui/ErrorPopupContext";
import ErrorPopupDialog from "./components/ui/ErrorPopupDialog";
import useNavigationBlocker from './hooks/useNavigationBlocker';

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        light:'#72c8bd',
        main: '#4FBAAD',
        dark:'#47a79c'
      },
      secondary:{
        light:'#ed7148',
        main:'#E94E1B',
        dark:'#a33612',
      },
      error:{
        light:'#ed7148',
        main:'#E94E1B',
        dark:'#a33612',
      }
    },
  });

  const [dateError, setDateError] = useState(false);
  const [siteId, setSiteId] = useState(null);
  const [nameOfCompleting, setNameOfCompleting] = useState('');
  const [timeDate, setTimeDate] = useState(null);

  const [userType, setUserType] = useState('');

  const [categoryId, setCategoryId] = useState(null);
  const[description, setDescription] = useState('');

  const[contacted, setContacted] = useState(null);
  
  const [contactEmail, setContactEmail] = useState('');
  const [contactNumber, setContactNumber] = useState('');

  const [imgFile, setImgFile] = useState();
  const [file, setFile] = useState([]);

  const navigate = useNavigate();
  const current_url = window.location.pathname;

useNavigationBlocker(
  ["/", "/success"],    // static ignored routes
  []          // optional dynamic patterns, 
);

  return (

    <StyledEngineProvider injectFirst>
     <ErrorPopupProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeProvider theme={theme}>
          <AppBar />
          <PageTracker siteId={siteId} nameOfCompleting={nameOfCompleting} timeDate ={timeDate} userType={userType} categoryId={categoryId} description={description} contacted={contacted} contactEmail={contactEmail} contactNumber={contactNumber} />
          <Routes>
            <Route path="/" element={<Home siteId={siteId} setSiteId={setSiteId} nameOfCompleting={nameOfCompleting} setNameOfCompleting={setNameOfCompleting} timeDate ={timeDate} setTimeDate={setTimeDate} dateError={dateError} setDateError={setDateError} userType={userType} setUserType={setUserType} />} />
            <Route path="/wos" element={<WorkingOnSite categoryId={categoryId} setCategoryId={setCategoryId} description={description} setDescription={setDescription} />} />
            <Route path="/mop" element={<MemberOfThePublic categoryId={categoryId} setCategoryId={setCategoryId} description={description} setDescription={setDescription}/>} />
            <Route path="/image_upload" element={<ImageUpload imgFile={imgFile} setImgFile={setImgFile} file={file} setFile={setFile}/>}/>
            <Route path="/contact" element={<Contact siteId={siteId} setSiteId={setSiteId} nameOfCompleting={nameOfCompleting} setNameOfCompleting={setNameOfCompleting} timeDate ={timeDate} setTimeDate={setTimeDate} dateError={dateError} setDateError={setDateError} userType={userType} setUserType={setUserType} categoryId={categoryId} setCategoryId={setCategoryId} description={description} setDescription={setDescription} contacted={contacted} setContacted={setContacted} contactEmail={contactEmail} setContactEmail={setContactEmail} contactNumber={contactNumber} setContactNumber={setContactNumber} imgFile={imgFile} setImgFile={setImgFile} file={file} setFile={setFile}/>} />
            <Route path="/success" element={<Success />} />
            <Route path="*" element={<Error />} />
          </Routes>
          <ErrorPopupDialog />
        </ThemeProvider>

      </LocalizationProvider>
      </ErrorPopupProvider>
    </StyledEngineProvider>

  );
}

export default App;
